import React, { useEffect, useState } from "react";
import axios from "axios";
import { Notify } from "notiflix";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProfileCard = ({ profile }) => (
    <div className="profile-card">
        <div className="profile-img-wrapper">
            <img
                src={`https://kovaikongunadumatrimony.com/kkm_admin/public/assets/prof_images/${profile.profile_photo_1}`}
                alt="Profile"
                className="profile-img"
            />
        </div>
        <div className="profile-details">
            <p><strong>பதிவு எண்</strong>: {profile.profile_id}</p>
            <p><strong>பெயர் </strong>: {profile.name}</p>
            <p><strong>வயது </strong>: {profile.age}</p>
            <p><strong>ஜாதகம் </strong>: {profile.jathagam}</p>
            <p><strong>நட்சத்திரம்  </strong>: {profile.star}</p>
            <p><strong>ராசி </strong>: {profile.rasi}</p>
            <p><strong>தொலைபேசி எண் 1</strong>: {profile.mobile_number}</p>
            <p><strong>தொலைபேசி எண் 2</strong>: {profile.alternative_number}</p>
        </div>
    </div>
);

const ProfileCardSkeleton = () => (
    <div className="profile-card">
        <div className="profile-img-wrapper">
            <Skeleton height={150} />
        </div>
        <div className="profile-details">
            <p><Skeleton width={120} /></p>
            <p><Skeleton width={150} /></p>
            <p><Skeleton width={100} /></p>
            <p><Skeleton width={130} /></p>
            <p><Skeleton width={140} /></p>
            <p><Skeleton width={100} /></p>
            <p><Skeleton width={160} /></p>
            <p><Skeleton width={160} /></p>
        </div>
    </div>
);

const PurchasedProfileSection = () => {
    const [showAll, setShowAll] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const visibleProfiles = showAll ? profiles : profiles.slice(0, 4);

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem("kkm_auth"));
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        setLoading(true);
        axios
            .get(
                "https://kovaikongunadumatrimony.com/kkm_backend/public/api/purchase-mobile-number-List",
                { headers }
            )
            .then((response) => {
                if (response.data.status === true) {
                    setProfiles(response.data.data);
                } else {
                    Notify.failure(response.data.message);
                }
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className={`all-profiles-section ${showAll ? "scrollable" : ""}`}>
            <h2>Purchased Mobile Numbers ({profiles.length})</h2>
            <div className="row profiles-grid">
                {loading
                    ? Array(4).fill(0).map((_, index) => (
                        <div className="col-xl-6 col-12 mb-4" key={index}>
                            <ProfileCardSkeleton />
                        </div>
                    ))
                    : visibleProfiles.reverse().map((profile, index) => (
                        <div className="col-xl-6 col-12 mb-4" key={index}>
                            <ProfileCard profile={profile} />
                        </div>
                    ))
                }
            </div>
            {!loading && profiles.length > 4 && (
                <div className="view-all-wrapper">
                    <button
                        className="view-all-btn"
                        onClick={() => setShowAll(!showAll)}
                    >
                        {showAll ? "Show Less" : "View All"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default PurchasedProfileSection;
